import { compose, pure } from "recompose";

const newCompose = (...args) => {
  args = [pure, ...args, pure];
  return compose(...args);
};

export default newCompose;
